import type { OwedVisit } from './bank-match'

// The bank screen and money brought from Squeegee (0043, release step 5; PLAN sections 2 and 5). Pure, so every rule
// is tested without a screen. Only on a round with brought money: what a customer owes on an account is matched like a
// visit they owe ("£22 for the clean and £12 from Squeegee" is one £34 payment), and a payment from before their switch
// day is flagged "may already be in Squeegee" until the owner says which (Liam Q9).

// An account owing, offered to the matching as one more thing the customer owes. Its id is the account's, negative,
// so it can never be taken for a visit; its date is before any statement, so any payment can be for it.
export const ACCOUNT_DATE = '2000-01-01'
export interface OwedAccount { id: number; customer_id: number; chaseable_pence: number }
export function accountsAsOwed(accounts: OwedAccount[]): OwedVisit[] {
  return accounts
    .filter((a) => a.chaseable_pence > 0)
    .map((a) => ({ cleanId: -a.id, customerId: a.customer_id, date: ACCOUNT_DATE, pence: a.chaseable_pence, version: 0, status: 'unpaid' as const, chased: 0, account: true }))
}
export const isAccount = (v: OwedVisit): boolean => v.cleanId < 0

// What a payment pays, apart: the visits (by id and version) and the accounts (by id and pence).
export function splitPaid(visits: OwedVisit[]): { visits: { id: number; version: number }[]; accounts: { id: number; pence: number }[] } {
  return {
    visits: visits.filter((v) => !isAccount(v)).map((v) => ({ id: v.cleanId, version: v.version })),
    accounts: visits.filter(isAccount).map((v) => ({ id: -v.cleanId, pence: v.pence })),
  }
}

// The switch day of each customer with an account, the Squeegee payments brought with them, and the bank payments the
// owner has already said are new money (GET /api/bank-refs on a round with brought money).
export interface SwitchInfo { customer_id: number; day: string; payments: { id: number; on_date: string | null; pence: number; text: string }[] }
export interface Flag {
  day: string
  // Squeegee payments of the same amount within 3 days: the evidence it may be the same money.
  evidence: { id: number; on_date: string | null; pence: number; text: string }[]
}
const dayNumber = (d: string): number => Date.parse(`${d}T00:00:00Z`) / 86_400_000
export const EVIDENCE_DAYS = 3
export function switchFlag(payment: { date: string; pence: number }, ref: string, customerId: number, info: SwitchInfo[], newMoney: Set<string>): Flag | null {
  const s = info.find((x) => x.customer_id === customerId)
  if (!s || payment.date > s.day || newMoney.has(ref)) return null
  return {
    day: s.day,
    evidence: s.payments.filter((p) => p.pence === payment.pence && !!p.on_date && Math.abs(dayNumber(p.on_date) - dayNumber(payment.date)) <= EVIDENCE_DAYS),
  }
}
